import { render, staticRenderFns } from "./AddNewProtocol.vue?vue&type=template&id=3925972f&scoped=true"
import script from "./AddNewProtocol.vue?vue&type=script&lang=js"
export * from "./AddNewProtocol.vue?vue&type=script&lang=js"
import style0 from "./AddNewProtocol.vue?vue&type=style&index=0&id=3925972f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925972f",
  null
  
)

export default component.exports